"use client";

import { useEffect } from "react";

export const RedirectToRemedium = () => {
  useEffect(() => {
    window.location.href = "/";
  }, []);
  return <></>;
};
